import React, { useState, useEffect, useRef } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "./../servicios/auth.service";
import Logo from "./../recursos/logo.png";
import cebra from "./../recursos/cebra-magenta.png";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        El Campo es obligatorio
      </div>
    );
  }
};
const validEmail = (value) => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        El email introducido no es valido
      </div>
    );
  }
};

const Login = (props) => {
  const form = useRef();
  const checkBtn = useRef();

  const [usuario, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const onChangeUsername = (e) => {
    const usuario = e.target.value;
    setUsername(usuario);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };
  useEffect(() => {
    document.title = "Acceso al Panel de Fichaje";
  }, []);
  const handleLogin = (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(usuario, password).then(
        // En caso de login correcto
        (r) => {
          console.log("login correcto", r);
          const resMessage =
            (r.response && r.response.data && r.response.data.message) ||
            r.message ||
            r.toString();

          setLoading(false);
          setMessage(resMessage);
          setUsername("");
          setPassword("");
          if (r.status) {
            navigate("/");
          }
          // window.location.reload();
        },
        // En caso de login incorrectoi
        (error) => {
          console.log("login incorrecto");
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
          setMessage(resMessage);
        },
      );
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="col-xs-12 paginalogin margenboton">
      {/* <Link to={"/"} className="">
          Principal
        </Link> */}

      <div
        // style="background-color: rgba(0, 0, 0, 0.125);"
        className="card card-container"
      >
        <Typography align="center" variant="h4" component="h3" gutterBottom>
          Acceso al panel de fichajedigital.com
        </Typography>
        <img
          // src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          src={Logo}
          alt="profile-img"
          className="profile-img-card"
        />

        <Form onSubmit={handleLogin} ref={form}>
          <div className="form-group">
            <label htmlFor="usuario">Usuario</label>

            <Input
              type="text"
              className="form-control"
              name="usuario"
              value={usuario}
              onChange={onChangeUsername}
              validations={[required]}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <Input
              type="password"
              className="form-control"
              name="password"
              value={password}
              onChange={onChangePassword}
              validations={[required]}
            />
          </div>

          <div className="form-group margenboton">
            <Button
              className="btn btn-primary btn-block"
              variant="contained"
              // disabled={loading}
              onClick={handleLogin}
            >
              <span>Login</span>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
            </Button>
            {/* <button
              className="btn btn-primary btn-block"
              disabled={loading}
              style={{
                backgroundColor: '#C0DB1A',
                borderColor: '#B3B8BB',
                color: '#ffffff',
              }}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Login</span>
            </button> */}
          </div>
          {/* <a href="https://www.youtube.com/watch?v=WLkeANKdlSo"> */}

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          <CheckButton style={{ display: "none" }} ref={checkBtn} />
        </Form>
      </div>
    </div>
  );
};

export default Login;
